/* @ngInject */
const editDispositionsModal = (
  $uibModal,
  wagonRequest,
  $q,
  toaster,
  wagonFormat,
  utils
) => {
  const self = {}

  self.open = (_fieldName, _fieldLabel, _data) => {
    return $uibModal.open({
      template: require('./editDispositions.html'),
      resolve: {
        fieldName: () => { return _fieldName },
        fieldLabel: () => { return _fieldLabel },
        data: () => { return _data },
      },
      /* @ngInject */
      controller: ($scope, $uibModalInstance, data) => {
        $scope.submit = async (disposition) => {
          if (!disposition) return toaster.warning('Veuillez entrer une disposition')
          const responses = []

          const serverDisposition = utils.copy(disposition)
          serverDisposition.date = utils.date.stringToServer(disposition.date)
          const formattedDisposition = utils.copy(disposition)
          formattedDisposition.date = utils.date.stringToTimestamp(disposition.date)

          for (let index = 0; index < data.length; index++) {
            const wagon = wagonFormat.server(data[index])
            try {
              responses.push(wagonRequest.addNewDisposition(serverDisposition, wagon.id))
              data[index].dispositions.push({
                workshop: disposition.workshop,
                date: formattedDisposition.date,
              })
              if (data[index].dispositionDate <= +formattedDisposition.date || !data[index].dispositionDate) {
                data[index].dispositionDate = disposition.date
                data[index].workshop = disposition.workshop
              }
            } catch (error) {
              toaster.error(error)
            }
          }
          $q.all(responses)
          $uibModalInstance.close()
        }

        $scope.removeLastDisposition = async () => {
          try {
            const response = await wagonRequest.removeLastDisposition(data.map(w => w.id))
            console.log(response)
            for (let index = 0; index < data.length; index++) {
              data[index].dispositions.pop()

              const lastDisposition = data[index].dispositions[data[index].dispositions.length - 1]

              if (lastDisposition) {
                data[index].dispositionDate = lastDisposition.date
                data[index].workshop = lastDisposition.workshop
              } else {
                data[index].dispositionDate = ''
                data[index].workshop = ''
              }

            }
            toaster.message(response.message)
          } catch (error) {
            toaster.error(error)
          }

          $uibModalInstance.close()
        }

        $scope.cancel = () => {
          $uibModalInstance.close()
        }
      },
    })
  }

  return self
}
export default editDispositionsModal



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/trains/wagon/modals/editDispositions.modal.js